import {ShapeComponent, shapeComponent} from "set-state-compare/src/shape-component"
import memo from "set-state-compare/src/memo"
import React from "react"
import Route from "@kaspernj/api-maker/build/router/route"
import Switch from "@kaspernj/api-maker/build/router/switch"
import {useWoofRouter} from "shared/woof-router"
export default memo(shapeComponent(class RoutesAdminSchoolsRoute extends ShapeComponent {
  setup() {
    this.woofRouter = useWoofRouter()
  }

  render() {
    return (
      <Switch name="schools">
        <Route component="edit" exact path="new" />
        <Route component="account-schools" exact path=":school_id/account_schools" />
        <Route component="audits" exact path=":school_id/audits" />
        <Route component="school-roles" exact path=":school_id/school_roles" />
        <Route component="subscriptions" exact path=":school_id/subscriptions" />
        <Route component="edit" exact path=":school_id/edit" />
        <Route component="show" exact path=":school_id" />
        <Route component="index" exact />
        <Route componentPath="fallback" fallback onMatch={this.tt.onFallbackMatch} />
      </Switch>
    )
  }

  onFallbackMatch = () => this.woofRouter.setPageNotFound(true)
}))
